export const kanbanTasks = (tasks, state) => {
  const filteredTasks = tasks.filter((task) => {
    return task.state === state;
  });

  return filteredTasks;
};
